import { render, staticRenderFns } from "./DomainAsinInfo.vue?vue&type=template&id=29a9c02a&"
import script from "./DomainAsinInfo.vue?vue&type=script&lang=ts&"
export * from "./DomainAsinInfo.vue?vue&type=script&lang=ts&"
import style0 from "./DomainAsinInfo.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports